<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_40002599_2861)">
      <path
        d="M10.4993 4.08317V3.03317C10.4993 2.37978 10.4993 2.05308 10.3722 1.80351C10.2603 1.58399 10.0819 1.40552 9.86234 1.29366C9.61277 1.1665 9.28608 1.1665 8.63268 1.1665H5.36602C4.71262 1.1665 4.38592 1.1665 4.13636 1.29366C3.91684 1.40552 3.73836 1.58399 3.62651 1.80351C3.49935 2.05308 3.49935 2.37978 3.49935 3.03317V4.08317M3.49935 10.4998C2.95687 10.4998 2.68562 10.4998 2.46308 10.4402C1.85917 10.2784 1.38746 9.80668 1.22565 9.20277C1.16602 8.98023 1.16602 8.70899 1.16602 8.1665V6.88317C1.16602 5.90308 1.16602 5.41303 1.35675 5.03869C1.52453 4.7094 1.79225 4.44169 2.12153 4.27391C2.49588 4.08317 2.98592 4.08317 3.96602 4.08317H10.0327C11.0128 4.08317 11.5028 4.08317 11.8772 4.27391C12.2064 4.44169 12.4742 4.7094 12.6419 5.03869C12.8327 5.41303 12.8327 5.90308 12.8327 6.88317V8.1665C12.8327 8.70899 12.8327 8.98023 12.7731 9.20277C12.6112 9.80668 12.1395 10.2784 11.5356 10.4402C11.3131 10.4998 11.0418 10.4998 10.4993 10.4998M8.74935 6.12484H10.4993M5.36602 12.8332H8.63268C9.28608 12.8332 9.61277 12.8332 9.86234 12.706C10.0819 12.5942 10.2603 12.4157 10.3722 12.1962C10.4993 11.9466 10.4993 11.6199 10.4993 10.9665V10.0332C10.4993 9.37978 10.4993 9.05308 10.3722 8.80351C10.2603 8.58399 10.0819 8.40552 9.86234 8.29366C9.61277 8.1665 9.28608 8.1665 8.63268 8.1665H5.36602C4.71262 8.1665 4.38592 8.1665 4.13636 8.29366C3.91684 8.40552 3.73836 8.58399 3.62651 8.80351C3.49935 9.05308 3.49935 9.37978 3.49935 10.0332V10.9665C3.49935 11.6199 3.49935 11.9466 3.62651 12.1962C3.73836 12.4157 3.91684 12.5942 4.13636 12.706C4.38592 12.8332 4.71262 12.8332 5.36602 12.8332Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_40002599_2861">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
